import React, { useState, useEffect, useRef } from 'react';
import resources from '../../data/paliResources.json';   // <‑‑ new
import './ResourceSelector.css';

const ActiveResourceDisplay = ({ selectedResource, onSelect }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery,     setSearchQuery]   = useState('');
  const dropdownRef       = useRef(null);
  const searchInputRef    = useRef(null);

  // Default to the first resource (PaliGPT‑000)
  const effectiveSelectedId  = selectedResource || resources[0].id;
  const selectedResourceData =
    resources.find(r => r.id === effectiveSelectedId) || resources[0];

  // 🔎 Filter by name / title / description
  const filteredResources = resources.filter(r =>
    `${r.name} ${r.title} ${r.description}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  /* ---------- effects ---------- */
  useEffect(() => {
    const handleClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isDropdownOpen) searchInputRef.current?.focus();
    else                setSearchQuery('');
  }, [isDropdownOpen]);

  /* ---------- handlers ---------- */
  const toggleDropdown   = () => setIsDropdownOpen(o => !o);
  const handleSelect     = id => { 
    // Only call onSelect with reset flag if actually changing resources
    if (id !== effectiveSelectedId) {
      onSelect(id, true); // Pass true as second argument to indicate resource change
    } else {
      onSelect(id, false); // Same resource selected, no reset needed
    }
    setIsDropdownOpen(false);
  };
  const handleSearchChange = e => setSearchQuery(e.target.value);

  /* ---------- view ---------- */
  return (
    <div className="active-resource-container" ref={dropdownRef}>
      <div className="active-resource-display" onClick={toggleDropdown}>
        <div className="active-resource-info">
          <div className="active-resource-name">{selectedResourceData.name}</div>
          <div className="active-resource-title">{selectedResourceData.title}</div>
        </div>
        <div className={`active-resource-arrow ${isDropdownOpen ? 'open' : ''}`}>▼</div>
      </div>

      <div className={`resource-dropdown ${isDropdownOpen ? 'open' : ''}`}>
        <input
          ref={searchInputRef}
          className="resource-search-input"
          placeholder="Search resources…"
          value={searchQuery}
          onChange={handleSearchChange}
          onClick={e => e.stopPropagation()}
        />

        {filteredResources.length ? (
          filteredResources.map(r => (
            <div
              key={r.id}
              className={`resource-dropdown-item ${r.id === effectiveSelectedId ? 'selected' : ''}`}
              onClick={() => handleSelect(r.id)}
            >
              <div className="resource-dropdown-name">{r.name}</div>
              <div className="resource-dropdown-title">{r.title}</div>
            </div>
          ))
        ) : (
          <div className="resource-dropdown-no-results">No matching resources</div>
        )}
      </div>
    </div>
  );
};

export default ActiveResourceDisplay;
